import { SaveDataOrchestrator } from '@mental-mint/shared-utils';
import { GameId } from '@mental-mint/shared-types';
import { WordDriftSaveData, DEFAULT_WORD_DRIFT_SAVE_DATA } from '../types/SaveData';

/**
 * Game save helpers for WordDrift
 * Uses SaveDataOrchestrator directly for save/load operations
 */
export const loadWordDriftGame = async (): Promise<WordDriftSaveData> => {
  const saveObject = await SaveDataOrchestrator.loadGameData<WordDriftSaveData>(GameId.Taptionary);
  return saveObject?.savedGameData ?? DEFAULT_WORD_DRIFT_SAVE_DATA;
};

export const saveWordDriftGame = async (data: WordDriftSaveData): Promise<void> => {
  await SaveDataOrchestrator.saveGameData(GameId.Taptionary, data);
};
